var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItem3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82569 10.9566C8.12416 10.9566 7.48533 10.6894 7.0002 10.2539C6.51537 10.69 5.87563 10.9566 5.17349 10.9566C5.14184 10.9566 5.1114 10.953 5.08006 10.9518C4.94614 11.2302 4.86914 11.5407 4.86914 11.8697C4.86914 13.0441 5.8251 14.0001 6.99959 14.0001C8.17408 14.0001 9.13004 13.0441 9.13004 11.8697C9.13004 11.5398 9.04787 11.2312 8.91365 10.9521C8.88413 10.953 8.85521 10.9566 8.82569 10.9566Z",
    fill: "url(#paint0_linear_284_25090)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.651 2.43457C10.1148 2.43457 9.612 2.63605 9.22852 2.97996C9.54808 3.42765 9.738 3.97395 9.738 4.56499C9.738 5.15603 9.54808 5.70233 9.22852 6.15003C9.612 6.49394 10.1148 6.69541 10.651 6.69541C11.8255 6.69541 12.7815 5.73946 12.7815 4.56499C12.7815 3.39052 11.8255 2.43457 10.651 2.43457Z",
    fill: "#AD916F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7391 7.29992C10.7095 7.30084 10.6806 7.30449 10.6511 7.30449C9.97605 7.30449 9.32688 7.05553 8.82318 6.60449C8.50939 6.88601 8.13048 7.09479 7.7126 7.20831C7.84226 7.53183 7.91195 7.86996 7.91195 8.21753C7.91195 8.80735 7.72265 9.35304 7.4043 9.80043C7.78169 10.1395 8.279 10.3479 8.825 10.3479C9.99949 10.3479 10.9555 9.392 10.9555 8.21753C10.9555 7.88761 10.8733 7.57901 10.7391 7.29992Z",
    fill: "url(#paint1_linear_284_25090)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09295 7.29962C7.06161 7.30083 7.03117 7.30449 6.99952 7.30449C6.2986 7.30449 5.65977 7.0391 5.17525 6.60449C4.67155 7.05553 4.02237 7.30449 3.34732 7.30449C3.3178 7.30449 3.28888 7.30084 3.25936 7.29992C3.12514 7.57901 3.04297 7.88761 3.04297 8.21753C3.04297 9.392 3.99893 10.3479 5.17342 10.3479C6.34791 10.3479 7.30387 9.392 7.30387 8.21753C7.30387 7.88853 7.22687 7.57809 7.09295 7.29962Z",
    fill: "#AD916F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2603 4.56499C4.2603 3.97395 4.45021 3.42765 4.76978 2.97996C4.3863 2.63605 3.88351 2.43457 3.34725 2.43457C2.17276 2.43457 1.2168 3.39052 1.2168 4.56499C1.2168 5.73946 2.17276 6.69541 3.34725 6.69541C3.88351 6.69541 4.3863 6.49394 4.76978 6.15003C4.45021 5.70233 4.2603 5.15603 4.2603 4.56499Z",
    fill: "url(#paint2_linear_284_25090)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9997 1.82616C7.11597 1.82616 7.22949 1.8359 7.3421 1.8499C7.4331 1.19921 7.71341 0.864125 8.34189 0.581997C8.49528 0.513214 8.56376 0.333346 8.49498 0.179956C8.42619 0.0265654 8.24602 -0.0422167 8.09293 0.0268698C7.24532 0.407302 6.8454 0.928951 6.7334 1.83955C6.82075 1.83103 6.90962 1.82616 6.9997 1.82616Z",
    fill: "#AD916F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99959 6.69541C8.17621 6.69541 9.13004 5.74159 9.13004 4.56499C9.13004 3.38839 8.17621 2.43457 6.99959 2.43457C5.82298 2.43457 4.86914 3.38839 4.86914 4.56499C4.86914 5.74159 5.82298 6.69541 6.99959 6.69541Z",
    fill: "url(#paint3_linear_284_25090)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_284_25090",
    x1: 6.99959,
    y1: 10.2539,
    x2: 6.99959,
    y2: 14.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46372F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_284_25090",
    x1: 9.17987,
    y1: 6.60449,
    x2: 9.17988,
    y2: 10.3479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46372F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_284_25090",
    x1: 2.99329,
    y1: 2.43457,
    x2: 2.99329,
    y2: 6.69541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46372F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_284_25090",
    x1: 6.99959,
    y1: 2.43457,
    x2: 6.99959,
    y2: 6.69541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46372F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem3);
export default __webpack_public_path__ + "static/media/item3.f4661702abeccab4a25f4c3eb0ed818e.svg";
export { ForwardRef as ReactComponent };